import { Grid } from "@mui/material";
import { DisplayName, Plans } from "schemas/payments";

interface Props {
  plan: Plans;
}

const PlanStats = ({ plan }: Props) => {
  if (
    ![Plans.PRO, Plans.PRO_YEARLY, Plans.VA, Plans.VA_YEARLY]?.includes(plan)
  ) {
    return <></>;
  }

  return (
    <Grid item xs={12} sx={{ color: "#4A5565" }}>
      👉 {DisplayName[plan]} users are{" "}
      {plan === Plans.PRO || plan === Plans.PRO_YEARLY ? 11 : 33}x more likely
      to land a brand deal
    </Grid>
  );
};

export default PlanStats;
